module.exports = __webpack_public_path__ + "static/media/pdfdwg.7bb05fa2.png";